/**
 * A Firestore-ish timestamp → milliseconds, whatever shape it arrived in.
 *
 * ⚠️ SHARED 2026-09-20. Firestore hands back a Timestamp, a REST read hands back
 * an ISO string, a seeded fixture hands back a number, and `CallTranscriptDoc`
 * declares `receivedAt: unknown` precisely because all three occur. Activity had
 * the only implementation; the Calls page needed the same one rather than a
 * second that rounds a different way.
 */
export function tsToMs(value: unknown): number | null {
  if (value == null) return null
  if (typeof value === 'number') return value
  if (typeof value === 'string') {
    const p = Date.parse(value)
    return Number.isNaN(p) ? null : p
  }
  if (value instanceof Date) return value.getTime()
  if (typeof value === 'object') {
    const v = value as { toMillis?: () => number; seconds?: number }
    if (typeof v.toMillis === 'function') {
      try { return v.toMillis() } catch { return null }
    }
    if (typeof v.seconds === 'number') return v.seconds * 1000
  }
  return null
}
